module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "parallax"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "philosophy"
    }
  }, [_c('h2', [_vm._v("Une approche globale de la santé basée sur la prévention")]), _vm._v(" "), _c('div', {
    staticClass: "philosophy"
  }, [_c('h3', [_c('strong', [_vm._v("Nutrition")])]), _vm._v(" "), _c('h3', [_c('strong', [_vm._v("Comportement")])]), _vm._v(" "), _c('h3', [_c('strong', [_vm._v("Homéopathie")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-123eeceb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Fr/Philosophy.vue
// module id = 121
// module chunks = 0